import type { CSSProperties } from 'react'

interface Props {
  value: number
  size?: number
  color?: string
  weakZero?: string
  className?: string
  ariaLabel?: string
}

export function Money({
  value,
  size = 28,
  color = 'var(--cf-fg-primary)',
  weakZero = ',00',
  className = '',
  ariaLabel,
}: Props) {
  const negative = value < 0
  const absCents = Math.round(Math.abs(value) * 100)
  const wholeNum = Math.trunc(absCents / 100)
  const centsStr = (absCents % 100).toString().padStart(2, '0')
  const whole = wholeNum.toLocaleString('pt-BR')
  const dec = centsStr === '00' ? weakZero : `,${centsStr}`

  const vars = {
    '--cf-money-size': `${size}px`,
    '--cf-money-color': color,
  } as CSSProperties

  return (
    <span
      className={`cf-money ${className}`.trim()}
      aria-label={ariaLabel ?? `R$ ${whole}${dec.replace(',', ',')}${negative ? ' negativo' : ''}`}
      style={vars}
    >
      {negative && <span className='cf-money__neg'>−</span>}
      <span className='cf-money__sym'>R$</span>
      {whole}
      <span className='cf-money__dec'>{dec}</span>
    </span>
  )
}
